import React from 'react';
import { CardProps } from './consts';
import { Container, Header, HeaderContainer } from './styles';

export const Card: React.FC<React.PropsWithChildren<CardProps>> = ({
  children,
  className,
  header,
  subHeader,
  headerPosition,
  noOverflow,
  noPadding,
  noPaddingOnSmallScreen,
  transparent,
  ...otherProps
}) => {
  const hasHeader = !!(header || subHeader);
  return (
    <Container
      className={className}
      noOverflow={noOverflow}
      noPadding={noPadding}
      noPaddingOnSmallScreen={noPaddingOnSmallScreen}
      hasHeader={hasHeader}
      transparent={transparent}
      {...otherProps}>
      {hasHeader && (
        <HeaderContainer headerPosition={headerPosition} noPadding={noPadding}>
          <Header>{header}</Header>
          {subHeader && <Header isSubHeader>{subHeader}</Header>}
        </HeaderContainer>
      )}
      {children}
    </Container>
  );
};
